import { trackEvent } from '@/lib/omega';
import { requestCommonParams } from '@/lib/request/requestCommonParams';
import {
  setSessionStorage,
  getSessionStorage,
} from '@/utils/sessionStorage';
import { getLocalStorage } from '@/utils/localStorage';

/**
 *  @description 登录触发埋点 参数
 *  [
 *    sailing_c_x_login_common_ck
 *    sailing_c_x_login_callback_ck
 *  ]
 */
export const LOGIN_SOURCE_MAP = {
  index_btn: 1, // 首页登陆按钮
  shop_footer: 2, // 附近店铺底部引导登陆
  all_cart_checkout: 3, //全局购物车checkout
  shop_checkout: 4, // 单店check out
  sidebar: 5, // 侧边栏入口
  order: 6, // 订单页入口
  coupons: 7, // 券入口
  efo: 8, // efo入口
  pop: 9, // 天降弹窗
  code_popup: 10, // 券兑换码
};

// 埋点场景
export const LOG_SCENE_MAP = {
  efo: 2
}

/** @desc 添加唤起登录埋点标识 */
export const add_login_tag_logs_fun = async (pull_type) => {
  if (pull_type) {
    setSessionStorage('loginSource', pull_type);
  }
};

/** @desc 唤起登录埋点 */
export const login_common_logs_fun = async () => {
  const loginSource = getSessionStorage('loginSource') || ''; // 来源

  if (loginSource) {
    trackEvent({
      eventId: 'sailing_c_x_login_common_ck',
      eventLabel: '唤起登录页',
      attrs: {
        pull_type: loginSource,
      },
    });
  }
};

/** @desc 登录结果埋点 */
export const login_callback_logs_fun = async () => {
  const loginSource = getSessionStorage('loginSource') || ''; // 来源

  if (loginSource) {
    trackEvent({
      eventId: 'sailing_c_x_login_callback_ck',
      eventLabel: '登陆结果',
      attrs: {
        pull_type: +loginSource,
      },
    });
  }
};

/**
 * 背景：异常类型，前端异常、接口异常
 * 目标：快速排除接口异常导致的问题
 * 核心链路：用户手机号 -> uid -> traceId
 *
 * 参考链接：
 * 1. 手机号转uid：http://dbox.dtest.didichuxing.com/#/account/other
 * 2. 通过uid定位traceId：http://bigdata.intra.didiglobal.com/ddc_fetch_tools/sql.html#/sql?id=1
 * 3. 通过traceId排查接口问题：http://log.didichuxing.com/logRetrival/trace
 */
export const apiErrorLogs = (result = {}, path = '') => {
  try {
    const { errno, requestId, time, traceId } = result || {};
    const { deviceId } = requestCommonParams();
    const uid = getLocalStorage('uid') || '';

    if (traceId) {
      trackEvent({
        eventId: 'sailing_c_x_tech_api_error_bt',
        eventLabel: '接口请求异常埋点',
        attrs: {
          request_path: path,
          request_errno: errno,
          request_time: time,
          request_id: requestId,

          trace_id: traceId,
          device_id: deviceId,
          user_id: uid,
        },
      });
    }
  } catch (err) {
  }
};

/** @desc google GTM push */
export const googleGTM = (event) => {
  try {
    window.dataLayer && window.dataLayer.push({ event });
  } catch (err) {}
};

/** @desc 地址埋点参数 */
export const getAddressLogInfo = () => {
  try {
    const current_path =  window.location.pathname;
    let current_page = 1; // 地址页
    
    if (current_path.includes('food/feed')) {
      current_page = 2; // 首页
    } else if (current_path.includes('food/bill')) {
      current_page = 3;
    }
  
    return {
      current_page,
      current_path
    }
  } catch (error) {
    return {}
  }
}

export const jsApiErrorLogs = (result = {}) => {
  try {
    const { js_api = '', path = '', err_msg = '', user_agent = ''} = result;
      trackEvent({
        eventId: 'sailing_c_x_tech_js_error_bt',
        eventLabel: 'c端js异常监控',
        attrs: {
          js_api,
          path,
          err_msg,
          user_agent
        },
      });
  } catch (err) {
  }
};

